// Modules
import { ThemeProvider } from '@dasa-health/alma-react'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'

// Application
import { RedirectModal } from 'components/RedirectModal'
import logotypes from 'constants/logoTypes'
import { ROUTES_PATH } from 'constants/routesPath'
import { goToPage } from 'redesign/utils/goToPage'
import { navTheme } from 'styles/global'
import { getQueryParamsValue } from 'utils'

interface ParamsBrand {
    logo: string
    brandName: string
}

export const ScheduleRedirect: React.VFC = () => {
    const location = useLocation()
    const [paramsBrand, setParamsBrand] = useState<ParamsBrand>()
    const brandId = getQueryParamsValue(location, 'brandId')
    const productIds = getQueryParamsValue(location, 'productIds')
    const redirectTo = getQueryParamsValue(location, 'redirectTo')
    const origin = getQueryParamsValue(location, 'origin')

    const isSafari = useMemo(() => {
        const { userAgent } = navigator
        return userAgent.toLowerCase().includes('safari/') && !userAgent.toLowerCase().includes('chrome/')
    }, [])

    const showModal = useMemo(() => !!(brandId || redirectTo), [])

    const redirect = useCallback(() => {
        const formattedUrl = new URLSearchParams()

        if (brandId) {
            formattedUrl.append('brandId', brandId)
        }
        if (productIds) {
            formattedUrl.append('productIds', productIds)
        }

        formattedUrl.append('origin', origin || 'pagina_redirecionamento')

        const params = encodeURIComponent(formattedUrl.toString())

        const verifyUrl = redirectTo ? `?redirectTo=${redirectTo}` : ''

        goToPage(`${ROUTES_PATH.SIGN_IN}${verifyUrl}?${params}`)
    }, [location])

    useEffect(() => {
        if (brandId && logotypes[brandId]) {
            sessionStorage.setItem('@LiviaRedirect', JSON.stringify({ brandId }))
            setParamsBrand({ logo: logotypes[brandId].localLogo, brandName: logotypes[brandId].labName })
            return
        }
        goToPage(ROUTES_PATH.SIGN_IN)
    }, [location])

    useEffect(() => {
        if (!isSafari) {
            const timer = setTimeout(() => {
                redirect()
            }, 8000)
            if (!showModal) {
                clearTimeout(timer)
                goToPage(ROUTES_PATH.SIGN_IN)
            }
        }
    }, [isSafari])

    return (
        <ThemeProvider theme={navTheme}>
            {showModal && (
                <RedirectModal
                    isSafari={isSafari}
                    labelButton="Agendar pelo Nav Dasa"
                    paramsBrand={paramsBrand}
                    redirect={redirect}
                    subtitle={!isSafari ? 'Você está sendo redirecionado.' : 'Você será redirecionado.'}
                    title="O agendamento online agora é feito pelo Nav Dasa"
                />
            )}
        </ThemeProvider>
    )
}
